import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexPersist = new VuexPersist(
	{
		key: 'co.elumin.portal',
		storage: sessionStorage
	}
);

export default new Vuex.Store(
	{
		state:
		{
			clientKey: '',
			clientConfig: {},
			authSession: '',
			userSession: '',
			profile: undefined,
			loadedAt: new Date()
		},
		getters:
		{
			isLoggedIn: state => ((!!state.userSession) && (!!state.profile && !!('uuid' in state.profile) && !!state.profile.uuid))
		},
		mutations:
		{
			clientKey(state, v) { state.clientKey = v; },
			clientConfig(state, v) { state.clientConfig = v; },
			authSession(state, v) { state.authSession = v; },
			userSession(state, v) { state.userSession = v; },
			profile(state, v) { state.profile = v; },
			loadedAt(state, v) { state.loadedAt = v; }
		},
		actions:
		{
			async clear({ commit })
			{
				commit('clientKey', '');
				commit('clientConfig', {});
				commit('authSession', '');
				commit('userSession', '');
				commit('profile', null);
			},
			async clientKey({ commit }, v) { commit('clientKey', v); return this.state.clientKey; },
			async clientConfig({ commit }, v) { commit('clientConfig', v); return this.state.clientConfig; },
			async authSession({ commit }, v) { commit('authSession', v); return this.state.authSession; },
			async userSession({ commit }, v) { commit('userSession', v); return this.state.userSession; },
			async profile({ commit }, v) { commit('profile', v); return this.state.profile; },
		},
		plugins: [ vuexPersist.plugin ]
	}
);
